<template>
  <v-card>
    <v-card-title class="h6">
      <div class="d-flex flex-column">
        Global Info
        <span class="caption">last update: {{ getLocaleTime(info.updatedAt) }}</span>
      </div>
      <v-spacer />
      <v-btn
        icon
        color="grey"
        @click="getData"
      >
        <v-icon>{{ mdiReload }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="caption">Players</td>
              <td class="caption">{{ info.players }}</td>
            </tr>
            <tr>
              <td class="caption">Sessions</td>
              <td class="caption">{{ info.sessions }}</td>
            </tr>
            <tr>
              <td class="caption">Completion Rate (by sessions)</td>
              <td class="caption">{{ ((info.finished_sessions / (info.sessions || 1)) * 100).toFixed(2) }}% | {{ info.finished_sessions }} sessions finished</td>
            </tr>
            <tr>
              <td class="caption">Completion Rate (by players)</td>
              <td class="caption">{{ ((info.players_with_finished_sessions / (info.players || 1)) * 100).toFixed(2) }}% | {{ info.players_with_finished_sessions }} players finished</td>
            </tr>
            <tr>
              <td class="caption">Re-launches Rate (by players)</td>
              <td class="caption">{{ ((info.players - info.single_session_count) / (info.players || 1) * 100).toFixed(2) }}% | {{ info.players - info.single_session_count }} players has 2 or more sessions</td>
            </tr>
            <tr>
              <td class="caption">New game + (by players)</td>
              <td class="caption">{{ (info.new_game_plus_session_count / (info.players || 1) * 100).toFixed(2) }}% | {{ info.new_game_plus_session_count }} players started a "new game +"</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider class="mt-4"></v-divider>
      <v-simple-table class="mt-4" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per Session
              </th>
              <th class="text-left">
                Median per Session
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="caption">All</td>
              <td class="caption">{{ timeToString(info.avg_playtime_for_all) }}</td>
              <td class="caption">{{ timeToString(info.median_playtime_for_all) }}</td>
              <td class="caption">{{ timeToString(info.total_playtime_for_all) }}</td>
            </tr>
            <tr>
              <td class="caption">New game +</td>
              <td class="caption">{{ timeToString(info.avg_playtime_for_new_game_plus) }}</td>
              <td class="caption">{{ timeToString(info.median_playtime_for_new_game_plus) }}</td>
              <td class="caption">{{ timeToString(info.total_playtime_for_new_game_plus) }}</td>
            </tr>
            <tr>
              <td class="caption">Finished Sessions</td>
              <td class="caption">{{ timeToString(info.avg_time_for_finished) }}</td>
              <td class="caption">{{ timeToString(info.median_time_for_finished) }}</td>
              <td class="caption">{{ timeToString(info.total_time_for_finished) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-left">
                Avg per Session
              </th>
              <th class="text-left">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="caption">Shortcut unlocks</td>
              <td class="caption">{{ (info.shortcut_unlock / (info.sessions || 1)).toFixed(2) }}</td>
              <td class="caption">{{ info.shortcut_unlock }}</td>
            </tr>
            <tr>
              <td class="caption">Flashlight</td>
              <td class="caption">{{ (info.flashlight / (info.sessions || 1)).toFixed(2) }}</td>
              <td class="caption">{{ info.flashlight }}</td>
            </tr>
            <tr>
              <td class="caption">Save | Manual</td>
              <td class="caption">{{ (info.save_manual / (info.sessions || 1)).toFixed(2) }}</td>
              <td class="caption">{{ info.save_manual }}</td>
            </tr>
            <tr>
              <td class="caption">Save | Auto</td>
              <td class="caption">{{ (info.save_auto / (info.sessions || 1)).toFixed(2) }}</td>
              <td class="caption">{{ info.save_auto }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiReload } from '@mdi/js';
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: true,
      mdiReload,
      info: {
        updatedAt: 'not calculated yet'
      }
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-info`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.info = data
      }
      this.loading = false
    },
    getLocaleTime (datetimeString) {
      if (datetimeString === 'not calculated yet') {
        return datetimeString
      }

      const date = new Date(datetimeString).toLocaleTimeString('uk-UA', {
        hour: '2-digit',
        minute: '2-digit'
      })

      return date
    }
  }
}
</script>

